import { Chip } from "@/components/core/Chip";

interface VoteHeaderProps {
    participantCount: number;
    hasVoted?: boolean;
}

export const VoteHeader: React.FC<VoteHeaderProps> = ({}) => {
    return (
        <div className="my-3 flex items-center justify-between gap-2">
            <Chip className="mt-[3px] rounded-lg bg-gray-300 dark:border">
                밸런스 투표
            </Chip>
        </div>
    );
};
